// src/pages/policy/sections/UpdatePolicy.jsx
import { motion } from "framer-motion";
const item = {
  hidden: { opacity: 0, y: 6 },
  show: { opacity: 1, y: 0, transition: { duration: 0.16 } },
};

export default function UpdatePolicy() {
  return (
    <section className="mb-12 space-y-4 text-gray-700 text-[15px] leading-relaxed">
      <motion.h2
        className="text-2xl font-bold text-gray-800 mb-2"
        variants={item}
        initial="hidden"
        animate="show"
      >
        Chính sách cập nhật & thay đổi dịch vụ
      </motion.h2>

      <motion.p variants={item} initial="hidden" animate="show">
        Hệ thống có thể được cập nhật định kỳ hoặc đột xuất để cải thiện hiệu
        suất, bảo mật hoặc tuân thủ quy định pháp luật...
      </motion.p>

      <motion.ul
        className="list-disc list-inside ml-5 space-y-1"
        variants={item}
        initial="hidden"
        animate="show"
      >
        <li>Thông báo qua popup trong ứng dụng.</li>
        <li>Gửi email đến người dùng đã đăng ký.</li>
        <li>Cập nhật tại trang Chính sách chính thức.</li>
      </motion.ul>

      <motion.p variants={item} initial="hidden" animate="show">
        Việc tiếp tục sử dụng hệ thống sau khi có cập nhật đồng nghĩa với việc
        người dùng đồng ý với thay đổi đó...
      </motion.p>
    </section>
  );
}
